import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {RequestMethod, Response} from "@angular/http";
import {RequestConfig, RestResponse} from "../../shared/rest/rest.request";
import {CustomHttp} from "../../common/http/custom.http";
import {Categoria} from "../+configuraciones/+tickets/+categorias/categorias.service";
import {PageImpl} from "../../common/http/PageImpl";

@Injectable()
export class SlaService {
    private GET_PAGE_SLA = new RequestConfig("FTS", "application/json", true, RequestMethod.Get, '/sla/Search');
    private GET_INFO_TYPES_TICKET = new RequestConfig("TPT", "application/json", true, RequestMethod.Post, '/types/tickets/find');
    private GET_CATEGORIES = new RequestConfig("TCA", "application/json", true, RequestMethod.Post, '/tickets/categories/find');
   // private GET_PAGE = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, '/tickets/categories');
    private GET_PAGE = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, '/subCategory/{idCategory}');
    private CREATE_SLA = new RequestConfig("USR", "application/json", true, RequestMethod.Post, '/sla');
    private DELETE_SLA = new RequestConfig("USR", "application/json", true, RequestMethod.Delete, '/sla/{idSla}');
    private GET_SLA = new RequestConfig("USR", "application/json", true, RequestMethod.Get, '/sla/{idSla}');
    private EDIT_SLA = new RequestConfig("USR", "application/json", true, RequestMethod.Put, '/sla/{idSla}');
    constructor(private http: CustomHttp){
    }
    /**
     * Envia una petición a WS para obtener informacion completa de x tipos de tickets
     */
    getTiposTicket(): Observable<Array<TipoTicket>> {
        let tiposTicket: any = localStorage.getItem('tiposTicket');
        if (tiposTicket != undefined || tiposTicket != null) {
            let tiposTicketParse = JSON.parse(tiposTicket)
            if (tiposTicketParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(tiposTicketParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_INFO_TYPES_TICKET, {})
            .map((res: any) => {
                    try {
                        localStorage.setItem('tiposTicket', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
    }

    getCategories(request: TicketTypeRequestView): Observable<Array<Categoria>> {
        return this.http.sendRequest(this.GET_CATEGORIES, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    // getSubCategories(request?: any): Observable<Array<Categoria>> {
    //     return this.http.sendRequest(this.GET_PAGE, request)
    //         .map(res => res.json().content)
    //         .catch(error => this.http.handleError(error));
    // }

    getSubCategories(idCategory: number): Observable<ServiceLevelAgreement> {
        return this.http.sendRequest(this.GET_PAGE, {}, idCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }


    getPage(options: any): Observable<PageImpl<ServiceLevelAgreement>>  {
        return this.http.sendRequest(this.GET_PAGE_SLA, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    saveSla(sla: ServiceLevelAgreement): Observable<any> {
        return this.http.sendRequest(this.CREATE_SLA, sla).catch(error => this.http.handleError(error));
    }

    deleteSla(idSla: number) {
        return this.http.sendRequest(this.DELETE_SLA, {}, idSla)
            .catch(error => this.http.handleError(error));
    }

    getSla(idSla: number): Observable<ServiceLevelAgreement> {
        return this.http.sendRequest(this.GET_SLA, {}, idSla)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    updateSla(slaObject: ServiceLevelAgreementUpdate): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_SLA, slaObject, slaObject.idSla)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class ServiceLevelAgreement {
    idSla = null;
    descripcion: string;
    idCategoria?: number;
    idSubcategoria?: number;
    idTipoTicket?: number ;
    horarioNatural  = true;
    alertaPorcentaje: number;
    listSlaDetallesView: SlaDetailsView[];
}

export class ServiceLevelAgreementAdd {
    idSla = null;
    descripcion = '';
    idCategoria?: number = 0;
    idSubCategoria?: number;
    idTipoTicket?: number = 0;
    horarioNatural  = true;
    alertaPorcentaje: number;
    listSlaDetallesView: SlaDetailsView[];
}

export class ServiceLevelAgreementUpdate {
    idSla = null;
    descripcion = '';
    idCategoria?: number = 0;
    idSubcategoria?: number;
    idTipoTicket?: number = 0;
    horarioNatural  = true;
    alertaPorcentaje: number;
    listSlaDetallesView: SlaDetailsView[];
    idOrg:string;
}


export class SlaDetailsView {
    idSlaDetails = null;
    prioridad: number = 0;
    tiempoRespuesta: number = 0;
    tiempoResolucion: number = 0;
    idSla = null;
    escalacion1Resp= null;
    escalacion2Resp= null;
    escalacion3Resp= null;
    escalacion4Resp= null;
    escalacionTiempo1= null;
    escalacionTiempo2= null;
    escalacionTiempo3= null;
    subject: string = '';
    content: string = '';
    constructor(prioridad?: number, tiempoRespuesta?: number, tiempoResolucion?: number,
                escalacion1Resp?: string, escalacion2Resp?: string, escalacion3Resp?: string,
                escalacion4Resp?: string, escalacionTiempo1?: number,
                escalacionTiempo2?: number, escalacionTiempo3?: number, subject?: string, content?: string) {
        if (prioridad && tiempoRespuesta && tiempoResolucion && escalacion1Resp
            && escalacionTiempo1) {
            this.prioridad = prioridad;
            this.tiempoRespuesta = tiempoRespuesta;
            this.tiempoResolucion = tiempoResolucion;
            this.escalacion1Resp = escalacion1Resp;
            this.escalacion2Resp = escalacion2Resp;
            this.escalacion3Resp = escalacion3Resp;
            this.escalacion4Resp = escalacion4Resp;
            this.escalacionTiempo1 = escalacionTiempo1;
            this.escalacionTiempo2 = escalacionTiempo2;
            this.escalacionTiempo3 = escalacionTiempo3;
            this.subject = subject;
            this.content = content;
        }
    }
}


export class ListaErrorsForms {
    controlName: string;
    errorName: string;
    nombreReal: string;

    constructor(controlName?: string, errorName?: string, nombreReal?: string) {
        this.controlName = controlName;
        this.errorName = errorName;
        this.nombreReal = nombreReal || controlName;
    }
}



@Injectable()
export class TicketTypeRequestView {
    public idTicketTypes: Array<number>;
    public idTicketCategories: Array<number>;
    public idTypeTicket: number;
    public active: boolean;
}

@Injectable()
export class TipoTicket {
    public idTicketType: number;
    public ticketType: string;
    public typeTicket: string;
    public proccesInstanceName: string;
    public taskInstanceName: string;
    public prefix: string;
}
